import { css } from 'lit';

/**
 * Styles partagés (bouton rose, champ formulaire, conteneur récap, etc.)
 * Importés dans les composants concernés via `static styles = [tokens, shared, ...]`.
 */
export const shared = css`
  .btn {
    font-family: var(--sarah-font-display);
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 12px 24px;
    min-height: var(--sarah-tap-min, 44px);
    min-width: var(--sarah-tap-min, 44px);
    border: none;
    border-radius: var(--sarah-radius-btn);
    color: #fff;
    background-color: var(--sarah-rose);
    text-decoration: none;
    outline: 0;
    cursor: pointer;
    transition: background-color .15s;
  }
  .btn:hover { background-color: var(--sarah-rose-hover); }
  .btn:disabled {
    color: var(--sarah-disabled-fg) !important;
    background-color: var(--sarah-disabled-bg) !important;
    cursor: not-allowed !important;
  }
  @media (max-width: 719px) { .btn { width: 100%; } }

  .field { width: 100%; margin-bottom: 22px; }
  .field label {
    display: block;
    font-family: var(--sarah-font-body);
    font-size: 14px;
    color: var(--sarah-bleu);
    margin-bottom: 8px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }
  .field input,
  .field select,
  .field textarea {
    width: 100%;
    height: 56px;
    padding: 0 16px;
    font-family: var(--sarah-font-body);
    font-size: 16px;
    color: var(--sarah-text);
    background: #fff;
    border: 1.5px solid var(--sarah-border);
    border-radius: 6px;
    outline: none;
    transition: border-color .15s, box-shadow .15s;
    box-sizing: border-box;
  }
  .field select {
    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='%23355689' d='M0 0l6 8 6-8z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 16px center;
    padding-right: 40px;
  }
  .field textarea { min-height: 120px; height: auto; padding: 12px 16px; resize: vertical; line-height: 1.5; }
  .field input:focus,
  .field select:focus,
  .field textarea:focus {
    border-color: var(--sarah-bleu);
    box-shadow: 0 0 0 3px rgba(53, 86, 137, .15);
  }
  .field input:hover:not(:focus),
  .field select:hover:not(:focus),
  .field textarea:hover:not(:focus) { border-color: var(--sarah-border-hover); }
  .field .field-error {
    color: var(--sarah-error);
    font-size: 13px;
    margin-top: 6px;
    font-weight: 600;
  }

  .btn:focus-visible,
  .field input:focus-visible,
  .field select:focus-visible,
  .field textarea:focus-visible {
    outline: 3px solid var(--sarah-bleu);
    outline-offset: 2px;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .button-container {
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 20px;
  }
  @media (min-width: 720px) {
    .button-container { margin-left: 62px; }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
